
    <client-sign-in 
      [errorMsg]="authError$ | async"
      (signIn)="signIn($event)">
    </client-sign-in>
  